export default "__VITE_ASSET__DHWAbk_T__"